import React from "react";
import { AiFillEye } from "react-icons/ai";

const UserTable: React.FC<any> = ({ columns, data, onView }) => {
  const getBgColor = (text: string) => {
    if (text === "1") {
      return "#00b032";
    } else {
      return "#e06100";
    }
  };
  return (
    <div className="mt-4">
      <div className="relative overflow-x-auto max-h-[85vh] hide-scrollbar shadow-sm overflow-auto  sm:rounded-lg">
        <table className="w-full text-sm text-left  text-gray-500 font-poppins">
          <thead className="text-xs text-white sticky top-0 uppercase  bg-gray-700 ">
            <tr>
              {columns &&
                columns.map((column: any) => (
                  <th key={column} scope="col" className="px-6 py-3">
                    {column}
                  </th>
                ))}
            </tr>
          </thead>
          <tbody className="overflow-y-auto">
            {data &&
              data.map((item: any) => (
                <tr key={item.id} className="odd:bg-white border-b">
                  <td className="px-6 py-4 max-w-[15rem] h-[4rem] overflow-hidden text-ellipsis whitespace-nowrap">
                    {item.id}
                  </td>
                  <td className="px-6 py-4 max-w-[15rem] h-[4rem] overflow-hidden text-ellipsis whitespace-nowrap">
                    <div className="flex gap-2 items-center">
                      <img
                        src={
                          item.imageUrl !== ""
                            ? item.imageUrl
                            : "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png"
                        }
                        className="w-10 h-10 border rounded-full object-cover"
                      />
                      <div>
                        <h3 className="font-poppins max-w-[10rem] overflow-hidden text-ellipsis text-black font-semibold text-[0.9rem]">
                          {item.name}
                        </h3>
                      </div>
                    </div>
                  </td>

                  <td className="px-6 py-4 max-w-[15rem] h-[4rem] overflow-hidden text-ellipsis whitespace-nowrap">
                    {item.email}
                  </td>
                  <td className="px-6 py-4 max-w-[15rem] h-[4rem] overflow-hidden text-ellipsis whitespace-nowrap">
                    {item.phone}
                  </td>

                  <td className="px-6 py-4 max-w-[15rem] h-[4rem] overflow-hidden text-ellipsis whitespace-nowrap">
                    <div
                      className="px-3 py-1 text-xs font-poppins w-fit font-medium text-white rounded-full"
                      style={{
                        backgroundColor: getBgColor(item.isActive),
                      }}
                    >
                      {item.isActive === "1" ? "Active" : "Not Verified"}
                    </div>
                  </td>
                  <td className="px-6 py-4">
                    <div className="flex gap-4 items-center justify-center">
                      <div
                        onClick={() => onView(item)}
                        className="cursor-pointer bg-slate-200 rounded-full p-2"
                      >
                        <AiFillEye />
                      </div>
                    </div>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default UserTable;
